export enum LayoutsMap {
  DEFAULT = 'DEFAULT',
  HAPPY_FLOW = 'HAPPY_FLOW',
  EDGE_CASE = 'EDGE_CASE',
  BASIC = 'BASIC',
  EMPTY = 'EMPTY',
}

export enum RoutesMap {
  LOGIN = 'LOGIN',
  WELCOME = 'WELCOME',
  PHONE = 'PHONE',
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  IDENTITY = 'IDENTITY',
  HOME_ADDRESS = 'HOME_ADDRESS',
  PLAN_SELECTION = 'PLAN_SELECTION',
  KNOW_YOUR_BUSINESS = 'KNOW_YOUR_BUSINESS',
  BUSINESS_TYPE_SELECTION = 'BUSINESS_TYPE_SELECTION',
  REGISTERED_ADDRESS = 'REGISTERED_ADDRESS',
  BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  INDUSTRY = 'INDUSTRY',
  OWNER_CENTER = 'OWNER_CENTER',
  ADD_OWNER = 'ADD_OWNER',
  KYB_PENDING = 'KYB_PENDING',
  VERIFICATION_CENTER = 'VERIFICATION_CENTER',
  REVIEW = 'REVIEW',
  SUCCESS = 'SUCCESS',
  SUCCESS_WITHOUT_AUTO_LOGIN = 'SUCCESS_WITHOUT_AUTO_LOGIN',
  FAILD_UPLOAD = 'FAILD_UPLOAD',
  DEBIT_CARD_NAME = 'DEBIT_CARD_NAME',
  GENERIC_MESSAGE_PAGE = 'GENERIC_MESSAGE_PAGE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  ONE_OF_US = 'ONE_OF_US',
  KYC_FAILED = 'KYC_FAILED',
  ACCOUNT_OPENING_REASON = 'ACCOUNT_OPENING_REASON',
  INVITE_TEAM_MEMBER_INTRO = 'INVITE_TEAM_MEMBER_INTRO',
  VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER',
  SET_PASSWORD = 'SET_PASSWORD',
  INVITE_TEAM_MEMBER_FINISHED = 'INVITE_TEAM_MEMBER_FINISHED',
  NON_US_SOCURE = 'NON_US_SOCURE',
  LOGIN_OTP_VERIFICATION = 'LOGIN_OTP_VERIFICATION',
  RECOVERY = 'RECOVERY',
  RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST',
  SECURITY_QUESTION = 'SECURITY_QUESTION',
  RECOVERY_VERIFICATION_CODE = 'RECOVERY_VERIFICATION_CODE',
  RECOVERY_TYPE = 'RECOVERY_TYPE',
  RECOVERY_SET_PASSWORD = 'RECOVERY_SET_PASSWORD',
  RECOVERY_SUCCESS = 'RECOVERY_SUCCESS',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  UBO_ONBOARDING_INTRO = 'UBO_ONBOARDING_INTRO',
  UBO_ONBOARDING_VALIDATE_PHONE = 'UBO_ONBOARDING_VALIDATE_PHONE',
  UBO_ONBOARDING_ID_VERIFICATION = 'UBO_ONBOARDING_ID_VERIFICATION',
  UBO_ONBOARDING_CREATE_PASSWORD = 'UBO_ONBOARDING_CREATE_PASSWORD',
  UBO_ONBOARDING_DOCV = 'UBO_ONBOARDING_DOCV',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  EDD_ADDITIONAL_BUSINESS_LOCATIONS = 'EDD_ADDITIONAL_BUSINESS_LOCATIONS',
  EDD_INTERNATIONAL_ACTIVITY = 'EDD_INTERNATIONAL_ACTIVITY',
  EDD_BUSINESS_SIZE = 'EDD_BUSINESS_SIZE',
  EDD_ANNUAL_REVENUE = 'EDD_ANNUAL_REVENUE',
  EDD_INTENDED_USE = 'EDD_INTENDED_USE',
  EDD_WEBSITE_SOCIAL = 'EDD_WEBSITE_SOCIAL',
  EDD_BUSINESS_CAPITAL = 'EDD_BUSINESS_CAPITAL',
  EDD_FUNDING_SOURCES = 'EDD_FUNDING_SOURCES',
  EDD_NONPROFIT_FUNDING_SOURCES = 'EDD_NONPROFIT_FUNDING_SOURCES',
  EDD_NONPROFIT_DONORS = 'EDD_NONPROFIT_DONORS',
  EDD_NONPROFIT_ORGANIZATION_SIZE = 'EDD_NONPROFIT_ORGANIZATION_SIZE',
  EDD_NONPROFIT_MONTHLY_ACTIVITY = 'EDD_NONPROFIT_MONTHLY_ACTIVITY',
  EDD_NONPROFIT_AFFILIATION = 'EDD_NONPROFIT_AFFILIATION',
  EDD_NONPROFIT_SOCIAL_MEDIA = 'EDD_NONPROFIT_SOCIAL_MEDIA',
  EDD_ORGANIZATION_ROLE = 'EDD_ORGANIZATION_ROLE',
  EDD_NONPROFIT_DESCRIPTION = 'EDD_NONPROFIT_DESCRIPTION',
  EDD_NONPROFIT_DESCRIPTION_B = 'EDD_NONPROFIT_DESCRIPTION_B',
  EDD_NONPROFIT_DESCRIPTION_C = 'EDD_NONPROFIT_DESCRIPTION_C',
  EDD_NONPROFIT_DESCRIPTION_D = 'EDD_NONPROFIT_DESCRIPTION_D',
  EDD_NONPROFIT_DESCRIPTION_E = 'EDD_NONPROFIT_DESCRIPTION_E',
  EDD_BENEFICIARY_SELECTION = 'EDD_BENEFICIARY_SELECTION',
  EDD_EMBEDDED_WHAT_DO_YOU_SELL = 'EDD_EMBEDDED_WHAT_DO_YOU_SELL',
  EDD_EMBEDDED_TO_WHO_YOU_SELL = 'EDD_EMBEDDED_TO_WHO_YOU_SELL',
  EDD_EMBEDDED_WHY_DID_YOU_CHOOSE = 'EDD_EMBEDDED_WHY_DID_YOU_CHOOSE',
  EDD_EMBEDDED_BUSINESS_COUNTRIES = 'EDD_EMBEDDED_BUSINESS_COUNTRIES',
  EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME = 'EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME',
  EDD_SANCTIONED_COUNTRIES = 'EDD_SANCTIONED_COUNTRIES',
  EDD_CHARITIES = 'EDD_CHARITIES',
  EDD_MILITARY_PRECIOUS_METALS = 'EDD_MILITARY_PRECIOUS_METALS',
  EDD_CASH_PAYMENTS = 'EDD_CASH_PAYMENTS',
  EDD_TAX_LEGAL_SERVICES = 'EDD_TAX_LEGAL_SERVICES',
  EDD_FUND_TRANSFER = 'EDD_FUND_TRANSFER',
  EDD_INVESTMENT_CUSTODIAL = 'EDD_INVESTMENT_CUSTODIAL',
  CDD_ACH_VOLUMES = 'CDD_ACH_VOLUMES',
  CDD_DOMESTIC_WIRE_VOLUMES = 'CDD_DOMESTIC_WIRE_VOLUMES',
  CDD_INTERNATIONAL_WIRES_VOLUMES = 'CDD_INTERNATIONAL_WIRES_VOLUMES',
  AUTO_LOGIN = 'AUTO_LOGIN',
  MULTI_BUSINESS_ONBOARDING_INTRO = 'MULTI_BUSINESS_ONBOARDING_INTRO',
  AUTH_USER_PHONE = 'AUTH_USER_PHONE',
  AUTH_USER_IDENTITY = 'AUTH_USER_IDENTITY',
  AUTH_USER_HOME_ADDRESS = 'AUTH_USER_HOME_ADDRESS',
  AUTH_USER_DOCV = 'AUTH_USER_DOCV',
  ACCOUNTANT_PORTAL_WELCOME = 'ACCOUNTANT_PORTAL_WELCOME',
  ACCOUNTANT_PORTAL_COMPLETE = 'ACCOUNTANT_PORTAL_COMPLETE',
}

// Used for TabIndexing form values
export function getRouteOrdinal(route: RoutesMap): number {
  return Object.keys(RoutesMap).indexOf(route) * 100;
}

export interface IRoute {
  id: string;
  name: string;
  path: string;
  layoutType: LayoutsMap;
  groupId?: string;
}
